import React from "react";

const C = {
  muted: "#6B85A3",
  border: "#D6E4F0",
  teal: "#2A9D8F",
  navy: "#1B3A5C",
};

const linkStyle: React.CSSProperties = {
  color: C.muted,
  textDecoration: "none",
  fontSize: 13,
  transition: "color .15s",
};

export default function SiteFooter() {
  return (
    <footer
      style={{
        backgroundColor: "#F7FAFE",
        borderTop: `1px solid ${C.border}`,
        padding: "32px 20px 24px",
        textAlign: "center",
      }}
    >
      {/* Badge de confiance sécurité */}
      <div style={{ marginBottom: 20 }}>
        <a
          href="/securite"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 16px",
            borderRadius: 20,
            backgroundColor: "#E6F5F4",
            border: `1px solid #B2DED9`,
            textDecoration: "none",
            transition: "background-color .15s",
          }}
        >
          <span style={{ fontSize: 15 }}>🔒</span>
          <span style={{ fontSize: 12, fontWeight: 700, color: C.teal }}>
            Données chiffrées AES-256 &amp; Hébergement UE sécurisé
          </span>
          <span style={{ fontSize: 11, color: C.muted }}>→</span>
        </a>
      </div>

      <div style={{ display: "flex", justifyContent: "center", gap: 24, flexWrap: "wrap" }}>
        <a href="/a-propos" style={linkStyle}>À propos</a>
        <span style={{ color: C.border }}>·</span>
        <a href="/pricing" style={linkStyle}>Tarifs</a>
        <span style={{ color: C.border }}>·</span>
        <a href="/securite" style={linkStyle}>Sécurité</a>
        <span style={{ color: C.border }}>·</span>
        <a href="/cgu" style={linkStyle}>CGU / CGV</a>
        <span style={{ color: C.border }}>·</span>
        <a href="/confidentialite" style={linkStyle}>Confidentialité</a>
        <span style={{ color: C.border }}>·</span>
        <a href="/mentions-legales" style={linkStyle}>Mentions légales</a>
        <span style={{ color: C.border }}>·</span>
        <a href="mailto:contact@freedomarchitect.io" style={linkStyle}>Contact</a>
      </div>

      {/* Disclaimer légal */}
      <p
        style={{
          marginTop: 16,
          fontSize: 11,
          color: C.muted,
          lineHeight: 1.6,
          maxWidth: 640,
          marginLeft: "auto",
          marginRight: "auto",
          fontStyle: "italic",
        }}
      >
        PsyGestion est un outil d'aide à la gestion. Les calculs et conseils de l'IA sont donnés
        à titre indicatif et ne remplacent pas les conseils d'un expert-comptable.
        Vous restez responsable de vos déclarations fiscales.
      </p>

      <p style={{ marginTop: 12, fontSize: 12, color: C.border }}>
        © {new Date().getFullYear()} PsyGestion — Freedom Architect — Tous droits réservés
      </p>
    </footer>
  );
}
